import {
    addFollow,
    FollowButton,
    withFollow,
} from '@eventbrite/follow-organizer-ebui';
import React, { useContext } from 'react';
import { EnvContext, UserContext } from '../context';
import { Organizer } from '../types';

interface FollowOrganizerWidgetProps {
    gaSettings: object;
    gaCategory: string;
    organizers: Organizer[];
    isAuthenticated: boolean;
    size?: string;
    renderFollowCount?: (
        followCount: string,
    ) => React.ReactNode | JSX.Element | null;
}

const EnhancedFollowButton = withFollow(FollowButton);
const FollowOrganizerWidget: React.FunctionComponent<
    FollowOrganizerWidgetProps
> = (props) => {
    return (
        <EnhancedFollowButton
            size={props.size}
            isOnlyButton={true}
            organizerId={props.organizers[0]}
            renderFollowCount={props.renderFollowCount}
        />
    );
};

interface FollowOrganizerProps {
    organizer: Organizer;
    size?: string;
    userId: string;
    renderFollowCount?: (
        followCount: string,
    ) => React.ReactNode | JSX.Element | null;
}

const EnhancedFollowOrganizerWidget = addFollow(FollowOrganizerWidget);
export const FollowOrganizer: React.SFC<FollowOrganizerProps> = (props) => {
    const { isAuthenticated } = useContext(UserContext);
    const { gaSettings } = useContext(EnvContext);
    const userId = props.userId;

    return (
        <EnhancedFollowOrganizerWidget
            isAuthenticated={isAuthenticated}
            gaSettings={gaSettings}
            gaCategory={'organizer'}
            organizers={[props.organizer.id]}
            renderFollowCount={props.renderFollowCount}
            size={props.size}
            userId={userId}
        />
    );
};
